export const isVerifyValid = (value: string) => /^\d{4}$/.test(value);
